export function initCampaignFaqs() {
	const $faq = jQuery('.campaign-faqs');
	if (!$faq.length) {
		return;
	}

	const $items = $faq.find('.campaign-faqs__item');
	if (!$items.length) {
		return;
	}

	$faq.on('click', '[data-faq-control="expand"]', function() {
		$items.prop('open', true);
	});

	$faq.on('click', '[data-faq-control="collapse"]', function() {
		$items.prop('open', false);
	});
}
